import { createContext, useContext } from 'react';
export const DeleteProductActionContext = /*#__PURE__*/createContext(undefined);
export const useDeleteProductAction = () => {
  const context = useContext(DeleteProductActionContext);
  if (context === undefined) {
    throw new Error('DeleteProductActionContext data is undefined. useDeleteProductAction must be used within a DeleteProductActionContext.Provider');
  }
  return context;
};